export default {
  transformer: {
    heroTag: 'Plataforma de Transformación',
    heroTitlePre: 'GPAX Transformer:',
    heroTitleHighlight: 'Oracle Forms to WEB',
    heroDesc: 'Transformamos tu aplicación Oracle Forms en una aplicación WEB de nueva generación y movemos tus datos a un motor de base de datos moderno.',
    diagramAlt: 'Proceso de transformación de GPAX',
    offerTitle: 'Nuestra Oferta',
    offerLine1: 'Transformamos tu aplicación',
    offerBold1: 'Oracle Forms',
    offerLine2: 'en una',
    offerBold2: 'aplicación WEB de nueva generación',
    offerLine3: 'y movemos tus datos a un',
    offerBold3: 'motor de base de datos moderno',
    contact: 'Contáctanos',
    featuresTitle: 'Características',
    feature1Title: 'Automático y confiable',
    feature1Desc: 'Transforma automáticamente el código PL/SQL a TypeScript, garantizando una transferencia segura de tu lógica de negocio al nuevo stack tecnológico.',
    feature2Title: 'Moderno y adaptable',
    feature2Desc: 'Transforma formularios y reportes en una interfaz WEB moderna y responsiva.',
    feature3Title: 'Independiente de la capa de datos',
    feature3Desc: 'Desacopla toda la lógica (fmb, rpf, pll, packages y stored procedures) en microservicios, eliminando cualquier dependencia de la capa de datos.',
    advantagesTitle: 'Ventajas',
    advantage1Title: 'Ahorra tiempo y dinero',
    advantage1Desc: 'Transforma tu aplicación en meses y por el 30% del costo de desarrollar desde cero.',
    advantage2Title: 'Cambio de paradigma',
    advantage2Desc: 'Usando la API, expone los procesos que actualmente están ocultos en el Form, para lograr una integración orgánica con el ecosistema digital.',
    advantage3Title: 'Amplio soporte',
    advantage3Desc: 'El stack tecnológico tiene una gran comunidad de programadores y soporte para Microsoft AD, georeferenciación, AI, etc.',
    ctaTitle: '¿Quieres saber más sobre nosotros?',
    contactButton: 'Contáctanos',
  },
};